<!-- ============================================================== -->
<!-- Only router without any element -->
<!-- ============================================================== -->
<mat-sidenav-container
  [ngClass]="{
    'cardBorder': options.cardBorder,
    orange_theme: options.activeTheme === 'orange_theme',
    blue_theme: options.activeTheme === 'blue_theme',
    aqua_theme: options.activeTheme === 'aqua_theme',
    purple_theme: options.activeTheme === 'purple_theme',
    green_theme: options.activeTheme === 'green_theme',
    pink_theme: options.activeTheme === 'pink_theme'
  }"
  [dir]="options.dir!"
>
  <router-outlet></router-outlet>
</mat-sidenav-container>
